import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import store from './store/'
import { nicedate } from './filters/datefilter.js'
import { playernames } from './filters/playernames-filter'
import { reversed } from './filters/reverse-filter'
import configureFakeBackend from './_helpers/fake-backend';

Vue.filter('nicedate', nicedate)
Vue.filter('playernames', playernames)
Vue.filter('reversed', reversed)

Vue.config.productionTip = false
Vue.use(BootstrapVue) 
Vue.use(IconsPlugin)

configureFakeBackend();

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
}).$mount('#app')

Vue.directive('focus', {
  inserted: function (el) {
      el.focus()
  }
})

